export const DATE_FORMAT = 'dd.MM.yyyy';
export const TIME_FORMAT = 'HH:mm';
export const KEY_DATE_FORMAT = 'DD.MM.YYYY';
export const KEY_TIME_FORMAT = 'HH:mm';
export const KEY_ENTER = 'Enter';
export const DATE_RANGE_SEPARATOR = '-';
export const CALENDAR_CLASSNAME = 'adnz';
export const CALENDAR_PORTAL_ID = 'react-datepicker-portal';
export const DATE_PICKER_REF = 'datePickerRef';
export const DEFAULT_TIME_INTERVALS = 15;
